var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-qa":"carddetails-div-34smjl"}},[(_vm.cardType === 'credit')?_c('v-flex',{attrs:{"data-qa":"carddetails-flex-3gpenm"}},[_c('CreditDetails',{attrs:{"config":{
        params: {
          cardId: _vm.cardId,
          cardName: _vm.cardName,
          cardBalance: _vm.cardBalance,
          cardCurrency: _vm.cardCurrency,
          cardMaskedNumber: _vm.cardMaskedNumber,
          cardStatus: _vm.cardStatus,
        },
      }}})],1):_vm._e(),(_vm.cardType === 'debit')?_c('v-flex',{attrs:{"data-qa":"carddetails-flex-rqmstv"}},[_c('DebitDetails',{attrs:{"config":{
        params: {
          cardId: _vm.cardId,
          cardAccountNumber: _vm.cardAccountNumber,
          cardName: _vm.cardName,
          cardMaskedNumber: _vm.cardMaskedNumber
        },
      }}})],1):_vm._e(),_c('v-flex',{staticClass:"my-4",attrs:{"data-qa":"carddetails-flex-ilw84g"}},[_c('v-divider',{attrs:{"data-qa":"carddetails-divider-0180t"}})],1),(_vm.tips.enabled)?_c('v-flex',{staticClass:"mb-1",attrs:{"data-qa":"carddetails-flex-hxgdi"}},_vm._l((_vm.tips.tipMessages),function(tip,i){return _c('v-alert',{key:tip,staticClass:"v-alert--info",attrs:{"icon":"mdi-information-outline","data-qa":`carddetails-alert-h0gdi-${i}`}},[_c('font',{staticClass:"body-2 font-weight-regular"},[_vm._v(" "+_vm._s(_vm.$t(`screenTips.${tip}`))+" ")])],1)}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }